module.exports = __webpack_public_path__ + "static/media/6.6b8c9e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/6.png
// module id = 785
// module chunks = 0